import { Component, Input } from '@angular/core';

@Component({
  selector: 'mat-icon',
  imports: [],
  templateUrl: './mat-icon.html',
  styleUrl: './mat-icon.scss',
})
export class MatIcon {
  @Input() color: string = undefined;
  @Input() size: number = 24;
  @Input() iconClass: string = undefined;
  @Input() iconStyle: string = undefined;

}
